module.exports = __webpack_public_path__ + "img/minilogo.34b9b0c3.png";